// ガイドテキスト
import React from 'react';

interface Props {
  label: string;
}

const GuideText: React.FC<Props> = ({ label }) => {
  // 改行コードをbr要素に置き換える
  const convertLine = () => {
    const node = label.split(/(\n)/);
    const texts = node.map((item, index) => {
      return <React.Fragment key={index}>{item.match(/\n/) ? <br /> : item}</React.Fragment>;
    });
    return texts;
  };

  return (
    <div className="guide-text">
      <p>{convertLine()}</p>
    </div>
  );
};

export default GuideText;
